import { NavLink } from 'react-router-dom'
import { LayoutDashboard, Package, ShoppingCart, MessageSquare, Settings } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useUIStore } from '@/store/uiStore'

const tabs = [
  { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/products', icon: Package, label: 'Products' },
  { to: '/orders', icon: ShoppingCart, label: 'Orders' },
  { to: '/ai-chat', icon: MessageSquare, label: 'AI Chat' },
  { to: '/settings', icon: Settings, label: 'Settings' },
]

export function BottomNav() {
  const { setChatOpen } = useUIStore()

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-surface border-t border-border safe-area-pb">
      <div className="flex items-center justify-around">
        {tabs.map((tab) => {
          if (tab.to === '/ai-chat') {
            return (
              <button
                key="ai-chat"
                onClick={() => setChatOpen(true)}
                className="flex flex-col items-center gap-0.5 py-3 px-4 text-muted"
              >
                <tab.icon className="w-5 h-5" />
                <span className="text-xs">{tab.label}</span>
              </button>
            )
          }
          return (
            <NavLink
              key={tab.to}
              to={tab.to}
              className={({ isActive }) =>
                cn(
                  'flex flex-col items-center gap-0.5 py-3 px-4 transition-colors',
                  isActive ? 'text-primary' : 'text-muted'
                )
              }
            >
              <tab.icon className="w-5 h-5" />
              <span className="text-xs">{tab.label}</span>
            </NavLink>
          )
        })}
      </div>
    </nav>
  )
}
